import axiosClient from "../axios/axiosClient";

export function getInstitutionCategories() {
  return axiosClient.get("/institution-categories");
}

export function getInstitutionCategory(institutionCategoryId) {
  return axiosClient.get(`/institution-categories/${institutionCategoryId}`);
}

export function createInstitutionCategory(data) {
  return axiosClient.post("/institution-categories", data);
}

export const updateInstitutionCategory = (institutionCategoryId, data) => {
  return axiosClient.put(
    `/institution-categories/${institutionCategoryId}`,
    data
  );
};

export function deleteInstitutionCategory(institutionCategoryId) {
  return axiosClient.delete(`/institution-categories/${institutionCategoryId}`);
}
